import { omit } from 'lodash';
import { shouldClearAdvancedSearchStateOnRouteChange } from '../../services/checkRouteChangesUtils';

const defaultState = {
  activePresetId: null,
  presets: [],
  suggestions: {},
  selectedTab: {},
  selectedProductTypes: [],
};

function advancedSearch(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'SET_ADVANCED_SEARCH_PRESETS':
      return { ...state, presets: action.presets };
    case 'SET_SELECTED_PRODUCT_TYPES':
      return { ...state, selectedProductTypes: action.types };
    case 'ADD_ADVANCED_SEARCH_PRESET':
      return { ...state, presets: state.presets.concat(action.preset) };
    case 'REMOVE_ADVANCED_SEARCH_PRESET':
      return { ...state, presets: state.presets.filter((p) => p.uuid !== action.id) };
    case 'SET_UPDATED_ADVANCED_SEARCH_PRESET':
      return {
        ...state,
        presets: state.presets.map((item) => {
          if (item.uuid === action.preset.uuid) {
            return { ...item, ...action.preset };
          }

          return item;
        }),
      };

    case 'SET_SELECTED_TAB_ADVANCED_SEARCH':
      return {
        ...state,
        selectedTab: {
          ...state.selectedTab,
          [action.id]: action.selectedTab,
        },
      };
    case 'SET_ACTIVE_ADVANCED_SEARCH_PRESET':
      return { ...state, activePresetId: action.id };
    case 'SET_ADVANCED_SEARCH_SUGGESTIONS':
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          [action.field]: action.suggestions,
        },
      };
    case 'REMOVE_ADVANCED_SEARCH_SUGGESTIONS':
      return { ...state, suggestions: omit(state.suggestions, action.field) };
    case 'HISTORY_LOCATION_CHANGE': {
      const { previousPathname } = action;
      const { pathname } = action;

      if (shouldClearAdvancedSearchStateOnRouteChange(previousPathname, pathname)) {
        return defaultState;
      }

      return state;
    }
    default:
      return state;
  }
}

export default advancedSearch;
